// extracted by mini-css-extract-plugin
export default {"filterIcon":"TaskTab_filterIcon__fMsbD","add-icon":"TaskTab_add-icon__cslxM","icon-24":"TaskTab_icon-24__VMlQS"};